// GERADO de backend-senne/src/contracts — NÃO editar; rode scripts/sync-contracts.sh

import { z } from 'zod'

/** Papéis-semente. Papel é um TEMPLATE (base) de permissões — não a unidade de acesso. */
export const roleCodeSchema = z.enum([
  'ADMIN',
  'HOSPITAL_MASTER',
  'HOSPITAL_USER',
  'PRESCRITOR',
  'MEDICO_INTERNO',
  'PACIENTE',
  'CONVENIO',
])
export type RoleCode = z.infer<typeof roleCodeSchema>

// `ROLE_SEED_TEMPLATES` viveu aqui e foi removido (G36): não tinha consumidor de
// produção em nenhum dos dois repos, e declarava para HOSPITAL_MASTER quatro
// permissões enquanto o piso que o runtime aplica dá uma só. Duas verdades sobre
// a base do papel, com valores diferentes. A viva é `ROLE_BASE_PERMISSIONS`, em
// `src/domain/rbac/role-base-permissions.ts`, keyed por `role_id` — que é a moeda
// das rotas de criação. Base por papel se altera lá.
